/** Authorized store scope shared by warehouse responses and insight evidence. */
import * as z from 'zod';
export const storeDataContextSchema = z.strictObject({
    shop: z.string().min(1),
    orgId: z.string().min(1),
    connectionId: z.string().min(1),
    revision: z.string().min(1),
});
//# sourceMappingURL=store-data-context.js.map